import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-3 text-center">
          <img
            src="/logo.png"
            alt="SPICE logo"
            className="h-20 w-20 object-contain mx-auto"
          />
            <CardTitle className="text-2xl font-bold tracking-tight">
              SPICE
            </CardTitle>
            <CardDescription>
              Security Profile Intelligent Creation Engine
            </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={() => login()}
            className="w-full"
            size="lg"
          >
            <Globe className="mr-2 h-5 w-5" />
            Sign in with Mercedes-Benz GAS
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            Authentication required for access
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
